export default __webpack_public_path__ + "static/media/gear-gray.3d59f061.svg";